// import mixpanel class from the library
import mixpanel from 'mixpanel-browser';
import { MIXPANEL_PRODUCTION_TOKEN, MIXPANEL_DEV_TOKEN } from '../../src/shared/constants';

// create an instance Mixpanel object using your project token
mixpanel.init(process.env.NODE_ENV === "production" ? MIXPANEL_PRODUCTION_TOKEN : MIXPANEL_DEV_TOKEN, {
  record_session_percent: 1,
  record_block_class: "embedded-checkout-container",
  record_heatmap_data: true,
  record_mask_text_selector: "",
});

export default mixpanel;
